import { IBrandingProvider } from "../IBrandingProvider";

export class DexterityBranding implements IBrandingProvider {
  getLogo(): string {
    return require('../../assets/Icons/newLogo.png');
  }
  getPrimaryColor(): string {
    return "#1976d2";
  }
}